module.exports = __webpack_public_path__ + "static/adam-ead940422d9b6662a653d0598b20d3f6.png";